'use strict';

module.exports = function isTrailingSurrogate(charCode) {
	return typeof charCode === 'number' && charCode >= 0xDC00 && charCode <= 0xDFFF;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isTrailingSurrogate.js
// module id = 554
// module chunks = 0